import styled from 'styled-components';

const StyledTransactionDetails = styled.div`
  .transaction-type {
    align-items: center;
    display: flex;

    svg {
      height: 24px;
      width: 24px;

      path:not([fill-rule="evenodd"]) {
        fill: ${props => props.theme.colors.neutral_6};
      }
    }
  }
`;


export {
  StyledTransactionDetails,
};
